import * as React from 'react';
import { connect } from 'react-redux';
import * as FormulaStore from '@/redux/pages/formula';
import store from '@/redux';
const Toast = require('react-toast-mobile');

class FormulaIntroduction extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            text: this.props.introduction || ''
        };
    }
    public render() {
        return (
            <section className="expert-intro">
                <div className="expert-intro-text" >
                    <textarea placeholder="请输入" defaultValue={this.state.text} onChange={() => this.inputChange('text')}></textarea>
                </div>
                <div className="expert-intro-btns">
                    <button className="btn-submit" onClick={() => this.submitAction()}>确定</button>
                </div>
            </section>
        )
    }

    /**
     * 输入处理
     * @param modelName {string} 模块名称
     */
    private inputChange(modelName: string) {
        this.setState({
            [modelName]: (event as any).target.value
        });
    }

    // 提交
    private submitAction() { 
        if (this.state.text === '') {
            return Toast.T.notify('请填写配方内容');
        } else if (this.state.text.length > 6000) { 
            return Toast.T.notify('配方内容不能超过6000个字');
        }
        store.dispatch({
            type: FormulaStore.types.INPUT,
            data: {
                key: 'introduction',
                value: this.state.text
            }
        });
        this.props.history.goBack();
    }
}

const mapStateToProps = (state: any):FormulaStore.IFormulaStoreState  => { 
    return {
        ...state.formulaReducers
    }
}
export default connect(mapStateToProps)(FormulaIntroduction);